import { toast as originalToast } from "react-toastify";
import { isDemoMode } from "./demoApiInterceptor";

// Wrapper for toast that disables error toasts in demo mode
export const toast = {
  success: (message, options) => {
    if (isDemoMode()) {
      // In demo mode, show success toasts normally
      return originalToast.success(message, options);
    }
    return originalToast.success(message, options);
  },
  error: (message, options) => {
    if (isDemoMode()) {
      // In demo mode, suppress error toasts
      return;
    }
    return originalToast.error(message, options);
  },
  info: (message, options) => {
    if (isDemoMode()) {
      return originalToast.info(message, options);
    }
    return originalToast.info(message, options);
  },
  warning: (message, options) => {
    if (isDemoMode()) {
      return originalToast.warning(message, options);
    }
    return originalToast.warning(message, options);
  },
  // Expose other toast methods
  dismiss: originalToast.dismiss,
  isActive: originalToast.isActive,
  update: originalToast.update,
  done: originalToast.done,
  onChange: originalToast.onChange,
  promise: originalToast.promise,
};

export default toast;
